import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { mapDatabaseLogToRecipeLog, type RecipeLog } from "@/features/RecipeLog/types";

/** Fetch the cook log for a recipe, newest first. */
export function useGetRecipeLogs(recipeId: number) {
    return useQuery<RecipeLog[]>({
        queryKey: ["recipeLogs", recipeId],
        queryFn: async () => {
            const { data, error } = await supabase
                .from("recipe_logs")
                .select("*")
                .eq("recipe_id", recipeId)
                .order("made_on", { ascending: false });

            if (error) throw error;
            return (data ?? []).map(mapDatabaseLogToRecipeLog);
        },
        enabled: recipeId > 0
    });
}
